/**Enum utilizzato per scegliere quale state cancellare*/
export enum ClearStateFlags {
    None,
    OrderEntry = 1 << 0,
    User = 1 << 1,
}
